/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cj_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. Fields wrapped in double quotes can contain commas and line breaks, and a doubled quote ("") is read as a literal quote, following the common CSV convention.`)
};

const es_cj_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí. Los campos envueltos en comillas dobles pueden contener comas y saltos de línea, y una comilla doble duplicada ("") se lee como una comilla literal, siguiendo la convención CSV común.`)
};

const de_cj_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Felder, die in doppelte Anführungszeichen gesetzt sind, können Kommas und Zeilenumbrüche enthalten, und ein doppeltes Anführungszeichen, das direkt zweimal hintereinander geschrieben wird, wird gemäß der üblichen CSV-Konvention als ein einzelnes wörtliches Anführungszeichen gelesen.`)
};

const nl_cj_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Velden die in aanhalingstekens zijn verpakt, kunnen komma's en regelbreeuken bevatten, en een verdubbeld aanhalingsteken ("") wordt als een letterlijk aanhalingsteken gelezen, volgens de algemene CSV-conventie.`)
};

const fr_cj_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui. Les champs entre guillemets doubles peuvent contenir des virgules et des sauts de ligne, et un guillemet doublé (guillemet répété deux fois) est lu comme un guillemet littéral, suivant la convention CSV courante.`)
};

const it_cj_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì. I campi racchiusi tra virgolette doppie possono contenere virgole e interruzioni di riga, e due virgolette consecutive sono lette come una virgoletta letterale, seguendo la convenzione CSV comune.`)
};

const pt_br2_cj_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. Campos envolvidos em aspas duplas podem conter vírgulas e quebras de linha, e uma aspa duplicada (duas aspas consecutivas) é lida como uma aspa literal, seguindo a convenção CSV comum.`)
};

const pt_cj_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. Os campos envolvidos em aspas podem conter vírgulas e quebras de linha, e duas aspas consecutivas são lidas como uma aspas literal, seguindo a convenção comum de CSV.`)
};

const ja_cj_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい。二重引用符で囲まれたフィールドはコンマと改行を含むことができ、二重の引用符（""）はリテラル引用符として読み取られます（一般的な CSV 慣例に従っています）。`)
};

const zh_cj_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`是的。用双引号包裹的字段可以包含逗号和换行符，按照通用的 CSV 约定，两个连续的双引号会被解析为字面意义上的引号字符。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cj_faq1_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cj_faq1_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cj_faq1_a", locale)
	if (locale === "en") return en_cj_faq1_a(inputs)
	if (locale === "es") return es_cj_faq1_a(inputs)
	if (locale === "de") return de_cj_faq1_a(inputs)
	if (locale === "nl") return nl_cj_faq1_a(inputs)
	if (locale === "fr") return fr_cj_faq1_a(inputs)
	if (locale === "it") return it_cj_faq1_a(inputs)
	if (locale === "pt-BR") return pt_br2_cj_faq1_a(inputs)
	if (locale === "pt") return pt_cj_faq1_a(inputs)
	if (locale === "ja") return ja_cj_faq1_a(inputs)
	return zh_cj_faq1_a(inputs)
};